export default __webpack_public_path__ + "static/media/research-robot.bf9eda4b.jpg";